import installCSSLink from "./installCSSLink";

/**
 * @param { object } fontFamily - [object] client font object, method uses install links, font name, font family name.
 * @returns { string } - [string] name of desired font family
 */
export const getDefaultFontFamily = ({ fontFamily }) => {
    if (!fontFamily) return "inherit";

    fontFamily.install_links.forEach((link) => {
        installCSSLink(link, "fod-font-" + fontFamily.name);
    });

    return fontFamily.font_family_name;
};
